export default "__VITE_ASSET__X7aO0Pyw__"